<template>
  <LocaleRichTextField
    :hide-label="true"
    :scope="[...scope, 'config']"
    :initial-value="config"
    :locales="locales"
    :errors="errors['config']"
  />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType, Locale, LocalString } from "@/types";
import { humanize, scopeToName } from "@/lib/candidacy/form_builder/utils";
import LocaleRichTextField from "@/components/backend/candidacy/form_builder/form_items/shared/LocaleRichTextField.vue";

export default defineComponent({
  name: "InformationItem",
  components: { LocaleRichTextField },
  methods: { scopeToName, humanize },
  props: {
    initialItem: {
      type: Object as PropType<LocalString>,
      required: true,
    },
    scope: {
      type: Array as PropType<string[]>,
      default: []
    },
    locales: {
      type: Array as PropType<Locale[]>,
      default: ["en"],
    },
  },
  data() {
    const initialItem = this.initialItem;
    return {
      id: initialItem.id,
      type: initialItem.type,
      item_type: initialItem.item_type,
      config: initialItem.config || {},
      errors: initialItem.errors || {},
    }
  },
});
</script>
